import { useState } from 'react';
import api from '../../shared/services/api/api';
import { useTranslation } from 'react-i18next';
import GenerateOrDownload from './GenerateOrDownload';
import ReportMessage from './ReportMessage';

type ReportStudioProps = {
  patientId: string;
};

const ReportSample = ({ patientId }: ReportStudioProps) => {
  const { t } = useTranslation();
  const [reportPdf, setReportPdf] = useState<{ data: string; message: string } | null>(null);
  const type = 1;
  const handleDownloadReport = async () => {
    const response = await api.generateSampleReport({ type, patientId });
    setReportPdf(response);
  };
  return (
    <div>
      <ReportMessage message={reportPdf?.message} />
      <div className="max-w-xl">
        <GenerateOrDownload
          handler={handleDownloadReport}
          link={reportPdf?.data}
          handlerLabel={t('generate sample report')}
          linkLabel={t('download sample report')}
        />
      </div>
    </div>
  );
};

export default ReportSample;
